import React from 'react'

import { IContentfulBlogPost } from '../../logic/shared-types'

import BlogPostPreview from './BlogPostPreview'

import './BlogPostList.scss'

const BlogPostList = ({ posts }: { posts: IContentfulBlogPost[] }) => (
  <div className="blogPostList">
    {posts.map(node => (
      <BlogPostPreview key={`preview-${node.contentful_id}`} {...node} />
    ))}
  </div>
)

export default BlogPostList
